<template>
  <div class="cardHeader">
    <span>{{ title }}</span>
    <div style="float: right; padding: 3px 0">
      <span v-for="(btn, index) in buttons || []" :key="index">
        <el-button
          :disabled="
            btn.changeMethod === 'save'
              ? saveDisabled
              : btn.changeMethod === 'instructionInvalid'
              ? instructionInvalidDisabled
              : btn.changeMethod === 'invalid'
              ? instructionInvalidDisabled
              : btn.changeMethod === 'batchIssued'
              ? batchIssuedDisabled
              : disabledFlag
          "
          class="btn"
          :type="btn.type"
          @click="handleBtns(btn.changeMethod)"
          >{{ btn.name }}</el-button
        >
      </span>
      <el-button
        v-if="settleType === 'all'"
        type="primary"
        style="margin-left: 12px"
        @click="cancel"
        >取消</el-button
      >
      <el-button
        v-if="settleType && turnType !== '0'"
        type="primary"
        style="margin-left: 12px"
        @click="handleSettleStatus"
        >查看结算状态</el-button
      >
    </div>
  </div>
</template>

<script>
  export default {
    name: 'cardHeader',
    props: ['title', 'buttons', 'turnType', 'currStatus', 'settleType'],
    computed: {
      saveDisabled() {
        let disabledFlag = false;
        if (this.turnType === '0' || this.turnType === '2') {
          disabledFlag = false;
        }
        if (this.turnType === '1') {
          if (
            this.currStatus === 'draft' ||
            this.currStatus === 'part_issued' ||
            this.currStatus === 'issued' ||
            this.currStatus === 'ongoing'
          ) {
            disabledFlag = false;
          } else {
            disabledFlag = true;
          }
        }
        if (this.turnType === '3') {
          disabledFlag = true;
        }
        return disabledFlag;
      },
      instructionInvalidDisabled() {
        return false;
      },
      disabledFlag() {
        // 0 新增可下发 1编辑 订单状态为草稿可下发 订单状态为下发 编辑可下发 2复制 可下发 3 详情不可下发
        // return this.turnType === '3' || (this.turnType === '1' && this.currStatus !== 'draft');
        let disabledFlag = false;
        if (this.turnType === '0' || this.turnType === '2') {
          disabledFlag = false;
        }
        if (this.turnType === '1') {
          if (this.currStatus === 'draft' || this.currStatus === 'part_issued') {
            disabledFlag = false;
          } else {
            disabledFlag = true;
          }
        }
        if (this.turnType === '3') {
          disabledFlag = true;
        }
        return disabledFlag;
      },
      batchIssuedDisabled() {
        return false;
      },
    },
    methods: {
      handleBtns(val) {
        this.$emit(val);
      },
      handleSettleStatus() {
        this.$emit('handleSettleStatus', this.settleType);
      },
      cancel() {
        this.$emit('cancel');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .btn {
    margin-left: 8px;
  }
</style>
